import React, { useState } from 'react';
import { Stack, Paper, Container, Grid } from '@mui/material';
import { LeftPanel } from '../left-panel';
import { backgroundColor, leftPnaleColor, rightPanelColor } from '../../assets/colors';
import { RightPanel } from '../right-panel';
import { Header } from '../header';

const Home = () => {
  const [selectedValue, setSelectedValue] = useState("");

  const handleSelectionChange = async (value: string) => {
    setSelectedValue(value);
  };

    return (
        <div style={{ background: leftPnaleColor, height: "100vh" }}>
            <Stack 
                direction="row"
                spacing="20px"
                padding={"20px"}
                flexWrap= {"wrap"}
                justifyContent= {"space-between"}
                alignItems= {"center"}
            >
                <Header />
            </Stack>
            <Grid container spacing={2} direction="row" alignItems="flex-start" bgcolor="#cceeff">
              <Grid item lg={4} xs={12} sm={6}>
                <LeftPanel onSelectionChange={handleSelectionChange} />
              </Grid>
              <Grid item lg={8} xs={12} sm={6}>
                <RightPanel selectedValue={selectedValue} />
              </Grid>
            </Grid>
        </div>
    );
}
export default Home;